import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { BaseComponent } from '@core/base.component';
import { ICON } from '@core/util/icon';
import {
	MatterChargeInstrument,
	MatterFileType,
	MatterTitle,
} from '@models/matter';
import { MatterMortgageWithAssociations } from '@models/mortgage';
import { Select } from '@ngxs/store';
import { NavigationService } from '@services/nav/nav.service';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';

export interface ReviewXmlFieldsComponentData {
	matterId: string;
	chargeObject: MatterChargeInstrument;
	mortgage: MatterMortgageWithAssociations;
	interestEstate: string;
	matterType: MatterFileType;
	matterTitles: MatterTitle[];
	missingFields: {
		message: string;
		action: () => void;
	}[];
}

interface VM {
	chargeObject?: MatterChargeInstrument;
	mortgage?: MatterMortgageWithAssociations;
	interestEstate?: string;
	matterTitles?: MatterTitle[];
	pinsText: string;
	missingFields: {
		message: string;
		action: () => void;
	}[];
}

const defaultVM: VM = {
	chargeObject: null,
	mortgage: null,
	interestEstate: null,
	matterTitles: [],
	missingFields: [],
	pinsText: '',
};

@Component({
	selector: 'app-review-xml-fields',
	templateUrl: './review-xml-fields.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ReviewXmlFieldsComponent
	extends BaseComponent<VM>
	implements OnInit
{
	@Select(SelectedMatter.chargeDetails)
	chargeDetails$: Observable<MatterChargeInstrument>;

	public ICON = ICON;

	constructor(
		private navigationService: NavigationService,
		private matterDispatch: MatterDispatch,
		@Inject(DRAWER_DATA) private data: ReviewXmlFieldsComponentData,
	) {
		super(defaultVM);
	}

	ngOnInit(): void {
		this.VM = {
			chargeObject: this.data.chargeObject,
			mortgage: this.data.mortgage,
			interestEstate: this.data.interestEstate,
			matterTitles: this.data.matterTitles,
			missingFields: this.data.missingFields,
			pinsText: this.data.matterTitles?.length > 1 ? 'PINs' : 'PIN',
		};
	}

	goToMortgage(): void {
		this.navigationService.goToMatter_Mortgages_Mortgage(
			this.data.matterId,
			this.data.mortgage.id,
		);
	}

	public goToMatterOverview = () => {
		this.navigationService.goToMatter_Overview(this.data.matterId);
	};

	public goToMatterPropertyDetails = () => {
		this.navigationService.goToMatter_Property(this.data.matterId, {
			'back-string': 'overview',
		});
	};

	public goToPurchaserOrBorrower = () => {
		if (this.data.matterType === MatterFileType.PURCHASE) {
			this.navigationService.goToMatter_Parties(this.data.matterId);
		} else if (this.data.matterType === MatterFileType.REFINANCE) {
			this.navigationService.goToMatter_Parties_Mortgagors(this.data.matterId);
		}
	};

	public updateDocumentName(event: string) {
		this.matterDispatch.SetChargeDetails(this.data.matterId, {
			[this.VM.mortgage?.id]: {
				documentName: event,
			},
		});
	}
}
